import { useTranslation } from 'react-i18next';

import { Tab } from '../Tab';

import { Affiliate } from './components/Affiliate';
import { Form } from './components/Form';
import { PermissionsTable } from './components/PermissionsTable';

export function Vtex() {
  const { t } = useTranslation('translation', {
    keyPrefix: 'pages.Settings.components.Vtex',
  });

  return (
    <Tab title={t('title')} description={t('description')}>
      <PermissionsTable />
      <Affiliate />
      <Form />
    </Tab>
  );
}
